/** Les ressources dont les fiches et les listes peuvent être gardées. */
export const RESSOURCES_HORS_LIGNE = ['oeuvres', 'artistes', 'expositions'];
/** Au-delà, sans nouvelle vérification de la session, tout s'efface. */
export const DUREE_MAX_HORS_LIGNE_HEURES = 72;
/** L'action de lecture qui ouvre chaque ressource. */
const LECTURE = {
    oeuvres: 'artworks:read',
    artistes: 'artists:read',
    expositions: 'exhibitions:read',
};
export function reglageHorsLigne(entree) {
    if (!entree.modules.includes('application-hors-ligne'))
        return null;
    // Un accès de support ouvre un rôle pour un temps : il n'emporte rien.
    if (entree.support || entree.etat !== 'active')
        return null;
    const perimetre = RESSOURCES_HORS_LIGNE.filter((ressource) => entree.actions.includes(LECTURE[ressource]));
    return perimetre.length === 0 ? null : { perimetre, dureeMaxHeures: DUREE_MAX_HORS_LIGNE_HEURES };
}
//# sourceMappingURL=horsLigne.js.map